import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchBooks } from '../../../../api/books'

export const fetchBooksThunk = createAsyncThunk(
  'books/fetch',
  async ({ access_token }) => {
    return await fetchBooks({ access_token }).then(res => res.json())
  },
)
